import { render, staticRenderFns } from "./KoioteNavigation.vue?vue&type=template&id=34a264ea&scoped=true&lang=es&"
import script from "./KoioteNavigation.vue?vue&type=script&lang=js&"
export * from "./KoioteNavigation.vue?vue&type=script&lang=js&"
import style0 from "./KoioteNavigation.vue?vue&type=style&index=0&id=34a264ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a264ea",
  null
  
)

export default component.exports